import omitDeep from '@wertarbyte/omit-deep';

export default omitDeep;
